import { SVG, IconProps } from "../SVG";
import React from "react";

export const HsaFsa = (props: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 48 65" {...props}>
        <rect
            width={32.837}
            height={22.91}
            x={9.743}
            y={10.35}
            fill="#5C5CFD"
            stroke="#F1F6FF"
            strokeWidth={1.527}
            rx={4.582}
            transform="rotate(-19.277 9.743 10.35)"
        />
        <path
            fill="#fff"
            d="m24.015 25.352-1.211.424-2.503-7.155 4.45-1.557.4 1.14-3.24 1.134.702 2.008 2.907-1.017.392 1.12-2.907 1.017 1.01 2.886ZM31.4 16.62l-.97.725c-.226-.42-.829-.945-1.788-.61-.726.254-1.061.915-.87 1.46.158.454.56.699 1.158.626l1.104-.148c1.35-.19 2.304.372 2.657 1.38.389 1.11-.14 2.485-1.774 3.056-1.817.636-3.064-.242-3.535-1.233l1.018-.718c.332.722 1.107 1.221 2.136.861.858-.3 1.15-.889.956-1.444-.163-.464-.636-.718-1.298-.633l-1.083.14c-1.168.16-2.145-.303-2.519-1.372-.42-1.201.334-2.575 1.666-3.04 1.686-.59 2.702.21 3.142.95Zm8.186 3.288-1.305-1.56-3.027 1.058-.038 2.03-1.282.448.283-8.13 1.403-.49 5.288 6.181-1.322.463Zm-4.234-5.078-.066 3.308 2.18-.762-2.114-2.546Z"
        />
        <path fill="#F1F6FF" d="M12.697 14.171 40.809 4.34l1.009 2.884-28.112 9.832z" />
        <rect
            width={32.837}
            height={22.91}
            x={5.665}
            y={24.209}
            fill="#A47FFE"
            stroke="#F1F6FF"
            strokeWidth={1.527}
            rx={4.582}
            transform="rotate(15 5.665 24.21)"
        />
        <path
            fill="#fff"
            d="m12.735 45.642-1.25-.335.838-3.129-3.438-.921-.839 3.129-1.24-.332 1.963-7.322 1.239.332-.81 3.026 3.438.921.81-3.026 1.25.335-1.961 7.322Zm8.258-3.797-1.21.052c.05-.474-.152-1.247-1.133-1.51-.743-.2-1.393.158-1.542.716-.125.464.07.893.605 1.169l.995.5c1.222.603 1.695 1.604 1.419 2.637-.305 1.136-1.514 1.974-3.187 1.526-1.86-.498-2.395-1.926-2.227-3.01l1.246-.02c-.133.783.226 1.632 1.28 1.914.877.236 1.45-.087 1.603-.655.127-.475-.121-.95-.715-1.254l-.975-.493c-1.055-.526-1.602-1.459-1.308-2.553.33-1.23 1.726-1.94 3.089-1.575 1.725.463 2.114 1.696 2.06 2.556Zm4.913 7.326-.2-2.023-3.097-.83-1.174 1.655-1.312-.351 4.812-6.558 1.436.384.888 8.086-1.353-.363Zm-.639-6.58-1.917 2.697 2.23.597-.313-3.293Z"
        />
        <path fill="#F1F6FF" d="m5.954 29.03 28.767 7.708-.79 2.951-28.768-7.708z" />
        <rect width={16.8} height={16.8} x={28.641} y={46.917} fill="#6A1DFE" rx={8.4} />
        <rect
            width={16.8}
            height={16.8}
            x={28.641}
            y={46.917}
            stroke="#F1F6FF"
            strokeWidth={1.527}
            rx={8.4}
        />
        <path
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.527}
            d="M36.12 55.779a2.305 2.305 0 0 0 3.474.25l1.382-1.385a2.307 2.307 0 0 0-1.637-3.908 2.303 2.303 0 0 0-1.62.647l-.793.789m1.036 2.684a2.306 2.306 0 0 0-2.65-.779c-.31.116-.59.297-.824.53l-1.382 1.384a2.307 2.307 0 0 0 1.637 3.909 2.303 2.303 0 0 0 1.62-.648l.788-.788"
        />
    </SVG>
);
HsaFsa.displayName = "HsaFsa";
